module.exports = "<div class=\"y-grid-wrapper\" style=\"margin-bottom: 0\">\n  <div class=\"y-grid\">\n    <y-grid-head params=\"convertedColumns:columns, columns:[columns]\"></y-grid-head>\n  </div>\n</div>\n<y-grid params=\"\n  isDataTable: isDataTable,\n  rows: rows,\n  columns: columns,\n  isSeparate:true,\n  minheight: minheight,\n  maxheight: maxheight,\n  nohead: true,\n  hasSummaryRow: true,\n  isStripe: false\">\n</y-grid>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/gridedit/index.html
// module id = 423
// module chunks = 0